import { ReactNode, ComponentType } from 'react';
import { ScholarshipSort, SortDirection } from '@common-types';
import { ScholarshipCardSkeleton } from '@components/ScholarshipCard/ScholarshipCardSkeleton';

import { SortByOption } from '@pages/Scholarships/components/SortBy';

import AllScholarships from '@pages/Scholarships/components/AllScholarships';
import Favorites from '@pages/Scholarships/components/Favorites';
import MyApplications from '@pages/Scholarships/components/MyApplications';

import ScholarshipIcon from '@images/ScholarshipsIcons/scholarship.svg?react';
import FellowshipIcon from '@images/ScholarshipsIcons/fellowship.svg?react';
import GrantIcon from '@images/ScholarshipsIcons/grant.svg?react';
import ForgivableLoanIcon from '@images/ScholarshipsIcons/forgivable-loan.svg?react';
import PrizeIcon from '@images/ScholarshipsIcons/prize.svg?react';

export const AWARD_TYPE_ICONS: { [key: string]: ReactNode } = {
  SCHOLARSHIP: <ScholarshipIcon />,
  FELLOWSHIP: <FellowshipIcon />,
  GRANT: <GrantIcon />,
  'FORGIVABLE LOAN': <ForgivableLoanIcon />,
  PRIZE: <PrizeIcon />,
};

export const PAGE_TABS_DATA: { [key: string]: { mode: number; component: ComponentType; name: string; hash: string } } =
  {
    allScholarships: {
      mode: 0,
      component: AllScholarships,
      name: 'All scholarships',
      hash: 'allScholarships',
    },
    favorites: {
      mode: 1,
      component: Favorites,
      name: 'Favorites',
      hash: 'favorites',
    },
    myApplications: {
      mode: 2,
      component: MyApplications,
      name: 'My applications',
      hash: 'myApplications',
    },
  };

export const FROM_MODE_TO_HASH: { [key: number]: string } = {
  [PAGE_TABS_DATA.allScholarships.mode]: PAGE_TABS_DATA.allScholarships.hash,
  [PAGE_TABS_DATA.favorites.mode]: PAGE_TABS_DATA.favorites.hash,
  [PAGE_TABS_DATA.myApplications.mode]: PAGE_TABS_DATA.myApplications.hash,
};

export const FROM_HASH_TO_MODE: { [key: string]: number } = {
  allScholarships: 0,
  favorites: 1,
  myApplications: 2,
};

export const SortByOptions: SortByOption[] = [
  { value: `${ScholarshipSort.DEADLINE},${SortDirection.ASC}`, label: 'Deadline: Earliest to Latest' },
  { value: `${ScholarshipSort.DEADLINE},${SortDirection.DESC}`, label: 'Deadline: Latest to Earliest' },
  { value: `${ScholarshipSort.NAME},${SortDirection.ASC}`, label: 'Name: A to Z' },
  { value: `${ScholarshipSort.NAME},${SortDirection.DESC}`, label: 'Name: Z to A' },
  { value: `${ScholarshipSort.AWARD},${SortDirection.ASC}`, label: 'Award: Lowest to Highest' },
  { value: `${ScholarshipSort.AWARD},${SortDirection.DESC}`, label: 'Award: Highest to Lowest' },
];

export const SCHOLARSHIP_CARD_SKELETONS = Array.from({ length: 6 }, (el, index) => ({
  id: index,
  skeleton: ScholarshipCardSkeleton,
}));
